import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { customStyles } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

const SelectGE = ({ value, onChange, disabled, placeholder = 'Grupo de Empresa' }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let ativo = true;
    setLoading(true);
    api
      .listarGruposEmpresaAutorizaDespesa()
      .then((res) => {
        if (!ativo) return;
        setOptions(res || []);
      })
      .catch((err) => {
        if (!ativo) return;
        setOptions([]);
        toast.error(
          err && err.message ? err.message : 'Falha ao carregar Grupos de Empresa.'
        );
      })
      .finally(() => {
        if (!ativo) return;
        setLoading(false);
      });
    return () => {
      ativo = false;
    };
  }, []);

  const opts = options.map((g) => ({
    value: g.codigo_grupo_empresa,
    label: `${g.codigo_grupo_empresa} - ${g.apelido || g.nome || ''}`,
  }));

  return (
    <Select
      styles={customStyles}
      options={opts}
      value={opts.find((o) => o.value === value) || null}
      onChange={(opt) => onChange(opt ? opt.value : null)}
      isDisabled={disabled || loading}
      isClearable
      isLoading={loading}
      placeholder={placeholder}
      noOptionsMessage={() => 'Nenhuma GE encontrada'}
    />
  );
};

export default SelectGE;
